import { render, staticRenderFns } from "./LabelPickerAdvancedFilters.vue?vue&type=template&id=22484b86&scoped=true"
import script from "./LabelPickerAdvancedFilters.vue?vue&type=script&lang=ts"
export * from "./LabelPickerAdvancedFilters.vue?vue&type=script&lang=ts"
import style0 from "./LabelPickerAdvancedFilters.vue?vue&type=style&index=0&id=22484b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22484b86",
  null
  
)

export default component.exports